module.exports = __webpack_public_path__ + "b727ba5fdbd3272b3fbd37225fd42cf2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/li.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/li.svg
// module chunks = 0